import * as React from 'react';
import { BarChart } from '@mui/x-charts/BarChart';

const TopIpGraph = ({ IPSourceApiCall }) => {
    if (!IPSourceApiCall || IPSourceApiCall.length === 0) {
        return <div>No data available</div>;
    }

    // Prepare dataset
    const dataset = IPSourceApiCall.map(item => ({
        ip: item._id,
        count: item.count,
    }));

    const chartSetting = {
        xAxis: [
            {
                label: '',
            },
        ],
        height: 400,
    };

    return (
        <BarChart
            dataset={dataset}
            yAxis={[{ scaleType: 'band', dataKey: 'ip' }]}
            series={[{ dataKey: 'count', label: 'Count' }]}
            layout="horizontal"
            {...chartSetting}
        />
    );
}
export default TopIpGraph;
